import { auth } from '../lib/firebase';

const AUTH_BACKEND_URL =
  import.meta.env.VITE_AUTH_BACKEND_URL || 'http://localhost:8080';

async function getIdToken(): Promise<string> {
  const user = auth.currentUser;
  if (!user) throw new Error('Vous devez être connecté en admin.');
  return user.getIdToken();
}

async function apiFetch<T>(
  path: string,
  init: { method: 'GET' | 'POST'; body?: Record<string, unknown> } = { method: 'GET' }
): Promise<T> {
  const token = await getIdToken();
  const response = await fetch(`${AUTH_BACKEND_URL}${path}`, {
    method: init.method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    ...(init.body ? { body: JSON.stringify(init.body) } : {}),
  });

  let payload: any = {};
  try {
    payload = await response.json();
  } catch {
    payload = {};
  }

  if (!response.ok) {
    const message = payload?.error || payload?.message || `Request failed (${response.status})`;
    const err = new Error(message) as Error & { status?: number; code?: string };
    err.status = response.status;
    err.code = payload?.code;
    throw err;
  }

  return payload as T;
}

export interface AdminOrgMemberImpact {
  userId: string;
  email: string | null;
  role: string | null;
  emailVerified: boolean;
  organizationCount: number;
  otherOrgCount: number;
  suggestedForSpamCleanup: boolean;
}

export interface AdminOrgDeletionImpactResponse {
  success: boolean;
  organization: {
    id: string;
    name: string;
    createdAt: string | null;
    creatorId: string | null;
    memberCount: number;
  };
  impact: Record<string, unknown>;
  members: AdminOrgMemberImpact[];
}

export async function fetchAdminOrgDeletionImpact(organizationId: string) {
  return apiFetch<AdminOrgDeletionImpactResponse>('/api/auth/admin/organization-deletion/impact', {
    method: 'POST',
    body: { organizationId },
  });
}

export async function adminDeleteOrganization(params: {
  organizationId: string;
  confirmationName?: string;
  userIdsToDelete?: string[];
}) {
  return apiFetch<{ success: boolean; message: string; result: unknown }>(
    '/api/auth/admin/delete-organization',
    {
      method: 'POST',
      body: {
        organizationId: params.organizationId,
        confirmationName: params.confirmationName,
        userIdsToDelete: params.userIdsToDelete ?? [],
      },
    }
  );
}

export async function adminDeleteUsers(params: { userIds: string[] }) {
  return apiFetch<{ success: boolean; message: string; result: unknown }>(
    '/api/auth/admin/delete-user',
    {
      method: 'POST',
      body: {
        userIds: params.userIds,
      },
    }
  );
}
